import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLogout } from './Auth.hooks';
import { clearPersistStorage } from '@services/query-client/QueryClient';
import { AppContext } from '../../../App.context';

export function Logout() {
	const navigate = useNavigate();
	const { clearCache } = useContext(AppContext);
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			const promises: Array<Promise<any>> = [clearPersistStorage()];
			if (clearCache) {
				promises.push(clearCache);
			}
			Promise.all(promises)
				.then(() => {
					navigate('/', { replace: true });
				})
				.catch(() => {
					navigate('/', { replace: true });
				});
		}
	}, [isLoading]);
	return <div />;
}
